module.exports = __webpack_public_path__ + "static/media/focus.39cae087.jpg";